import { protectedApi } from '@api/index';
import { formatApiResponse } from '@utils/helpers';

export async function getClinicsApi(page, limit,sorting, activeOnly = false ) {

  try {
      let sorturl=sorting?`&sort=${sorting.sort}&order=${sorting.order}`:""
      let activeUrl=activeOnly?`&active_only=1`:""
        const res = await protectedApi.get(`/clinics/?page=${page}&limit=${limit}${sorturl}${activeUrl}`);
        return formatApiResponse(res);
    
  } catch (e) {
    console.error('getClinicsApi.catch', e);
    return formatApiResponse(e);
  }
}

export const addClinicApi = async (clinicData) => {
  const endpoint = `/clinics/`;
  try {
    const response = await protectedApi.post(endpoint, clinicData);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

export async function getIndividualClinicsApi(clinicId) {
  try {
    const res = await protectedApi.get(`/clinics/${clinicId}`);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getIndividualClinicsApi.catch', e);
    return formatApiResponse(e);
  }
}

export const editClinicApi = async (id, clinicData) => {
  const endpoint = `/clinics/${id}`;
  try {
    const response = await protectedApi.put(endpoint, clinicData);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

// Every active clinic with its user count and active-user count (superuser only).
export async function getClinicUserCoverageApi() {
  const endpoint = `/clinics/coverage/`;
  try {
    const response = await protectedApi.get(endpoint);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}

export async function getClinicsListApi() {
  const endpoint = `/clinics/list/`;
  try {
    const response = await protectedApi.get(endpoint);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}

export async function editIndividualClinicStatusApi(data) {
  const endpoint = `/clinics/status/`;
  try {
    const response = await protectedApi.post(endpoint, data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}


export const checkClinicEmailApi = async (data,old_email='') => {
  const endpoint = `/clinics/validate-email/?email=${data}&old_email=${old_email}`;
  try {
    const res = await protectedApi.get(endpoint);
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};

// api for  get clinic detail for clinic  admin
export async function getClinicDetailApiForAdmin() {
  try {
    const res = await protectedApi.get(`/clinics/edit/`);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getIndividualClinicsApi.catch', e);
    return formatApiResponse(e);
  }
}

// api for  edit  clinic detail for clinic  admin
export const editClinicDetailApiForAdmin = async (clinicData) => {
  const endpoint = `/clinics/edit/`;
  try {
    const response = await protectedApi.put(endpoint, clinicData);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

// api to get all message template in clinic 
// clinicId is only meaningful for a superuser: a clinic admin is scoped to their own
// clinic server side whatever they send. Without it a portfolio login has no clinic of
// its own and the endpoint could not answer at all.
export const allMsgTepmplateApiForAdmin = async (clinicId) => {
  const endpoint = clinicId
    ? `/clinics/alltemplate/?clinic_id=${clinicId}`
    : `/clinics/alltemplate/`;
  try {
    const response = await protectedApi.get(endpoint);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

// api for Add message template in clinic 
export const addMsgTepmplateApiForAdmin = async (clinicData) => {
  const endpoint = `/clinics/addtemplate/`;
  try {
    const response = await protectedApi.post(endpoint, clinicData);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

// api for get message template in clinic 
export const getMsgTepmplateApiForAdmin = async (page, limit) => {
  try {
    const response = await protectedApi.get(`/clinics/addtemplate?page=${page}&limit=${limit}`);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

// api for edit message template in clinic 
export const editMsgTepmplateApiForAdmin = async (id) => {
  try {
    const response = await protectedApi.get(`/clinics/msgtemplate/edit/${id}`);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

// api for save edit message template in clinic 
export const editSaveMsgTepmplateApi = async (id,templateData,clinicId) => {
  try {
    // A save carries the clinic in the body, which is where the API looks for it on a
    // POST. A clinic admin's value is ignored in favour of their own clinic.
    const body = clinicId ? { ...templateData, clinic_id: clinicId } : templateData;
    const response = await protectedApi.post(`/clinics/msgtemplate/edit/${id}`,body);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

export async function FollowUpStatusChangeApi(data) {
  let endpoint;
  if(data['type'] === "call_rail")
    endpoint = `/calls/followup/update/`;
  else if (data['type'] === "gohighlevel")
    endpoint = `/gohighlevel/followup/update/`;
  else if (data['type'] === "websiteform")
    endpoint = `/websiteform/followup/update/`;
  else
    endpoint = `/calendly/followup/update/`;
  try {
    const response = await protectedApi.put(endpoint, data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}

export async function NeedFollowupChangeApi(data) {
  const endpoint = `/calls/need-followup/update/`;
  try {
    const response = await protectedApi.put(endpoint, data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}

export async function CallBackStatusChangeApi(data) {
  let endpoint = `/calls/callback-done/`;
  try {
    const response = await protectedApi.put(endpoint, data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}

export async function UpdateMissedCallReasonApi(data) {
  let endpoint = `/calls/missed-call-reason/`;
  try {
    const response = await protectedApi.put(endpoint, data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}

export async function UpdateNewPatientApi(data) {
  let endpoint = `/calls/update-new-patient/`;
  try {
    const response = await protectedApi.put(endpoint, data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}

export const getReportIssue = async (lead_id,source_type) => {
  try {
    const response = await protectedApi.get(`/clinics/tile-issue/?lead_id=${lead_id}&source_type=${source_type}`);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

export const saveReportIssue = async (data) => {
  try {
    const response = await protectedApi.post(`/clinics/tile-issue/`,data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

// `extra` is optional: { sort, order, search } for a caller that wants the whole
// portfolio ordered and filtered server side (the new console); omitted by the classic.
export const clinicsDashboardDetail = async (start_date, end_date, start_date2, end_date2, page, limit, clinic_id, type = '', extra = null) => {
  let endpoint = `/clinics/clinics-dashboard/?start_date=${start_date}&end_date=${end_date}&limit=${limit}&page=${page}&clinic_id=${clinic_id}`;
  if (extra) {
    if (extra.sort) endpoint += `&sort=${encodeURIComponent(extra.sort)}&order=${extra.order === 0 || extra.order === 'asc' ? 0 : 1}`;
    if (extra.search) endpoint += `&search=${encodeURIComponent(extra.search)}`;
  }
  if (type) {
    endpoint += `&type=${type}`;
  }
  if (start_date2 && end_date2) {
    endpoint += `&start_date2=${start_date2}&end_date2=${end_date2}`;
  }
  try {
    const response = await protectedApi.get(endpoint);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

export const exportClinicsDashboardToExcel = async (start_date, end_date, start_date2, end_date2, clinic_id, type = '') => {
  const endpoint = `/clinics/clinics-dashboard/`;
  try {
    const requestData = {
      export_type: 'excel',
      start_date: start_date,
      end_date: end_date,
      clinic_id: clinic_id
    };
    
    if (type) {
      requestData.type = type;
    }
    
    if (start_date2 && end_date2) {
      requestData.start_date2 = start_date2;
      requestData.end_date2 = end_date2;
    }
    
    const response = await protectedApi.post(endpoint, requestData, {
      responseType: 'blob' // Important for handling Excel file download
    });
    return response; // Return raw response for blob handling
  } catch (error) {
    return formatApiResponse(error);
  }
};